export class OneStepLink {
    id: number;
    identifier: string;
    startDate: Date;
    endDate: Date;
    logo: string;
    welcomeMessage: string;
}
